import NetworkClient, { ListResponse } from "../..";
import { endpoint } from "../../api";


export interface IPayloadSetBackOffice {
  daily_report_enabled: boolean | string | undefined;
  hour: string | undefined;
}

export interface IItemBackOfficeSettings {
  key: string;
  value: string;
}

export const getValues = (item?: IItemBackOfficeSettings[]): IPayloadSetBackOffice => {
  const getVal = (k: String): any | undefined => item?.find(i => i.key === k)?.value

  return {
    daily_report_enabled: getVal("daily_report_enabled") == "true",
    hour: getVal("hour")
  };
};


export const getBackOfficeSettings = (): Promise<ListResponse<IItemBackOfficeSettings>> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .get(endpoint.settings.general.get())
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};


export const updateBackofficeSettings = (data: IPayloadSetBackOffice): Promise<any> => {
  return new Promise((resolve, reject) => {
    NetworkClient()
      .patch(endpoint.settings.general.update(), data)
      .then((res: any) => {
        resolve(res?.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};